// Copyright (c) 2026 Deere & Company

import actions from '../../actions-list';

const defaultState = {
    currentPage: 1,
    lastOpenedRgaNumber: null,
    shouldRestore: false
};

const updateResultsNavigation = (state, action) => ({
    ...state,
    ...(action.resultsNavigation || {})
});

const resetResultsNavigation = () => ({...defaultState});

export default (state = defaultState, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_RESULTS_NAVIGATION]: updateResultsNavigation,
        [actions.RESET_RGA_RESULTS_NAVIGATION]: resetResultsNavigation
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/results-navigation.js